import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import image1 from "../../assets/banner1.jpg";
import image2 from "../../assets/banner7.jpg";
import image3 from "../../assets/banner6.jpg";

export default function ServiceDistribution() {
  return (
    <>
      <ServiceDetailPage
        label="Tipping"
        title="General Cargo Transportation: Tipping"
        subtitle="Bulk and loose-material transportation using tipping trailers paired with 6x4 tractor units for demanding field and construction operations."
        overview="NCCL tipping services are designed for high-efficiency unloading, quick turnarounds, and bulk movement where speed and reliability directly affect project timelines."
        images={[
          {
            src: image1,
            alt: "Tipping trailer operation",
            captionTitle: "Tipping Trailer Workflow",
            captionText: "Fast loading and unloading for aggregate and bulk materials.",
          },
          {
            src: image2,
            alt: "Heavy trailer fleet",
            captionTitle: "6x4 Tractor Units",
            captionText: "Strong pulling capacity for demanding transport routes.",
          },
          {
            src: image3,
            alt: "Bulk delivery",
            captionTitle: "Bulk Delivery Efficiency",
            captionText: "Operational model optimized for turnaround and continuity.",
          },
        ]}
        highlights={[
          "Tipping trailers built for fast discharge operations.",
          "6x4 tractor units for heavy-duty hauling performance.",
          "Ideal for bulk aggregates, coal, and loose cargo materials.",
        ]}
        metrics={[
          { value: "6x4", label: "Tractor unit class" },
          { value: "Fast", label: "Unload turnaround profile" },
          { value: "Bulk", label: "Material movement focus" },
        ]}
      />
      <Footer />
    </>
  );
}
